/* eslint-disable react/prop-types */
import PNG from "../imgs/Lincoln_logo.png";
import React from "react";

const LincolnLogo = ({ className, width }) => {
  return (
    <img
      data-testid="lincoln-logo"
      className={className}
      alt="LINCOLN"
      src={PNG}
      width={width}
    />
  );
};

export default LincolnLogo;
